<script setup lang="ts">
const props = defineProps({
  width: {
    type: Number,
    default: 400,
  },
})
const model = defineModel()
</script>

<template>
  <v-dialog v-model="model" :max-width="props.width" persistent>
    <slot></slot>
  </v-dialog>
</template>
